/**
 * 'CUSTOMER-BOOK-APPOINTMENT' : sent to the customer after the appointment book.
 *
 * 'INSURER-BOOK-APPOINTMENT' : sent to the insurer after the appointment book.
 *
 * 'FITTER-BOOK-APPOINTMENT' : sent to the fitter after the appointment book.
 *
 * 'FITTER-APPOINTMENT-SUGGESTIONS-CONFIRM' : sent to fitter when he makes an appointment proposal to the customer.
 *
 * 'CUSTOMER-APPOINTMENT-SUGGESTIONS-CONFIRM' : sent to customer following an appointment proposal by the fitter.
 *
 * 'FITTER-REBOOK-APPOINTMENT-CONFIRM' :
 *
 * 'CUSTOMER-RELAUNCH' : email sent to the customer (day -1) to remind him to choose an appointment among those suggested by the fitter
 *
 * 'FITTER-RELAUNCH' : email sent to the fitter (day -1) to inform him that the customer has not chosen an appointment among those suggested
 */
export type EmailType =
  | 'AGENDA-CUSTOMER-BOOK-APPOINTMENT'
  | 'AGENDA-CUSTOMER-REBOOK-APPOINTMENT'
  | 'AGENDA-CUSTOMER-NO-SHOW-APPOINTMENT'
  | 'AGENDA-CUSTOMER-COMPLETED-APPOINTMENT'
  | 'AGENDA-CUSTOMER-REMINDER'
  | 'AGENDA-CUSTOMER-CANCEL-APPOINTMENT'
  | 'AGENDA-FITTER-BOOK-APPOINTMENT'
  | 'AGENDA-UPLOAD-DOCUMENT'
  | 'AGENDA-FITTER-REBOOK-APPOINTMENT'
  | 'AGENDA-FITTER-CANCEL-APPOINTMENT'
  | 'CUSTOMER-ACCESS'
  | 'CUSTOMER-BOOK-APPOINTMENT'
  | 'CUSTOMER-REQUEST-APPOINTMENT'
  | 'CUSTOMER-REBOOK-APPOINTMENT-CONFIRM'
  | 'CUSTOMER-APPOINTMENT-SUGGESTIONS-CONFIRM'
  | 'CUSTOMER-RELAUNCH'
  | 'CUSTOMER-CANCEL-APPOINTMENT'
  | 'FITTER-PASSWORD-RESET'
  | 'FITTER-BOOK-APPOINTMENT'
  | 'FITTER-REQUEST-APPOINTMENT'
  | 'INSURER-REQUEST-APPOINTMENT'
  | 'FITTER-REBOOK-APPOINTMENT-CONFIRM'
  | 'FITTER-APPOINTMENT-SUGGESTIONS-CONFIRM'
  | 'FITTER-RELAUNCH'
  | 'FITTER-CANCEL-APPOINTMENT'
  | 'INSURER-PASSWORD-RESET'
  | 'INSURER-ACCESS'
  | 'INSURER-BOOK-APPOINTMENT'
  | 'INSURER-CANCEL-APPOINTMENT'
  | 'ADMIN-FITTER'
  | 'AARI-CONTACT'
  | 'NOTIFY-EXCEPTIONAL-CLOSING'
  | 'PARTNER-IMPORT-RESULT';
